$(function () {
  const $announcementBar = $('.announcement-bar');
  if ($announcementBar.length > 0 && $announcementBar.children().length > 0) {
    const $firstAnnouncement = $announcementBar.find('.announcement-bar__announcement').first();
    var announcementHeight = parseInt($firstAnnouncement.innerHeight());
    $announcementBar.css('height', announcementHeight + 'px');

    if ($announcementBar.children().length > 1) {
      $firstAnnouncement.clone().attr('data-announcement-index', $announcementBar.children().length).appendTo($announcementBar);
      const $announcements = $announcementBar.find('.announcement-bar__announcement');

      $announcements.each(function () {
        $(this).css('height', announcementHeight + 'px');
      });

      var activeIndex = 0;
      setInterval(() => {
        const $currentAnnouncement = $announcementBar.find('[data-announcement-index="' + activeIndex + '"]');
        activeIndex++;
        if (!$announcementBar.find('[data-announcement-index="' + activeIndex + '"]').length > 0) {
          activeIndex = 1;
        }
        const $nextAnnouncement = $announcementBar.find('[data-announcement-index="' + activeIndex + '"]');

        $currentAnnouncement.css('opacity', 0);
        $nextAnnouncement.css('opacity', 1);
      }, 8000);
    }
  }
});
